export function digitsOnlyKeyDownValidation(event) {
    // Allow some functional keys
    if (
        // Allow: backspace, delete, tab, escape, enter
        [46, 8, 9, 27, 13].includes(event.keyCode) ||
        // Allow: Ctrl+A, Ctrl+V, cmd+A, cmd+V
        ([65, 86].includes(event.keyCode) && (event.ctrlKey || event.metaKey)) ||
        // Allow: home, end, left, right
        ([35, 36, 37, 39].includes(event.keyCode))
    ) {
        // let it happen, don't do anything
        return
    }

    // Check that this is not a number and stop keypress handling
    if (
        (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) &&
        (event.keyCode < 96 || event.keyCode > 105)
    ) {
        event.preventDefault()
    }
}

export function getGroupsType(product) {
    if (product && product.groups) {
        const groupKeys = Object.keys(product.groups)
        return groupKeys[0].split(':')[0]
    }
}

function loadImages(urls) {
    return Promise.all(urls.map((url) => new Promise((resolve) => {
        const image = new Image()
        image.onload = () => resolve()
        image.onerror = () => resolve()
        image.src = url
        window.document.body[url] = image
    })))
}

export function preloadImages() {
    const context = require.context('../WGCWXShop', true, /\.(png|jpe?g|svg)$/)
    return loadImages(context.keys().map((image) => context(image)))
}

export function isCnRealm(realm) {
    return (realm === 'cn360')
}



// WEBPACK FOOTER //
// ./containers/WGCWXShop/helpers.js